<template>
  <div v-if="show" class="loading-overlay">
    <div class="spinner"></div>
    <div class="dots">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <p>{{ message }}</p>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: "Loading, please wait...",
    },
  },
};
</script>

<style scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(6px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 15px;
  z-index: 9999;
}

.spinner {
  width: 60px;
  height: 60px;
  border: 6px solid #e0e0e0;
  border-top: 6px solid#1f644c;
  border-radius: 50%;
  animation: spin 1s linear infinite, pulse 1.5s ease-in-out infinite;
}

p {
  font-size: 14px;
  color: #555;
  animation: fadeIn 1s ease-in-out infinite alternate;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.15);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0.4;
  }
  to {
    opacity: 1;
  }
}

.spinner {
  width: 64px;
  height: 64px;
  position: relative;
}

.spinner::before,
.spinner::after {
  content: "";
  position: absolute;
  border-radius: 50%;
  border: 6px solid transparent;
}

.spinner::before {
  width: 100%;
  height: 100%;
  border-top-color: #1f644c;
  animation: spin 1s linear infinite;
}

.spinner::after {
  width: 80%;
  height: 80%;
  top: 10%;
  left: 10%;
  border-bottom-color: #1f644c;
  animation: spinReverse 1.2s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes spinReverse {
  to {
    transform: rotate(-360deg);
  }
}

.dots {
  display: flex;
  gap: 8px;
}

.dots span {
  width: 10px;
  height: 10px;
  background: #147452;
  border-radius: 50%;
  animation: bounce 0.6s infinite alternate;
}

.dots span:nth-child(2) {
  animation-delay: 0.2s;
}
.dots span:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes bounce {
  from {
    transform: translateY(0);
    opacity: 0.6;
  }
  to {
    transform: translateY(-10px);
    opacity: 1;
  }
}
</style>
